// src/hooks/useButtonColor.js
import { useState, useEffect, useContext } from "react";
import axios from "axios";
import { AdminContext } from "@/context/AdminContext";
import { useHistory } from "react-router-dom";
import Cookies from "js-cookie";
import useCheckTokenExpired from "@/hooks/useCheckTokenExpired";

const Base_URL = import.meta.env.VITE_APP_API_BASE_URL;

const useButtonColor = () => {
  const [buttonColor, setButtonColor] = useState("var(--p-green)"); // Default color
  const { state, dispatch } = useContext(AdminContext);
  const { adminInfo } = state;
  const history = useHistory();
  const checkTokenExpired = useCheckTokenExpired(); // ✅ hook used properly
  const fetchConfiguration = async () => {
    if (!adminInfo?.token) {
      dispatch({ type: "USER_LOGOUT" });
      Cookies.remove("adminInfo");
      history.push("/login");
      return;
    }
    try {
      const headers = {
        "Content-Type": "application/json",
        authorization: `Bearer ${adminInfo.token}`,
      };
      const response = await axios.get(`${Base_URL}/configuration`, {
        headers,
      });
      if (checkTokenExpired(response)) return;
      const configuration = response.data[0];

      if (configuration && configuration.buttons_color) {
        setButtonColor(configuration.buttons_color);
      }
    } catch (error) {
      console.error("Failed to fetch button color:", error);
    }
  };

  useEffect(() => {
    fetchConfiguration(); // 🚀 Fetch only once on component mount
  }, []); // No polling, no setInterval

  return buttonColor;
};

export default useButtonColor;
